<sirius-grid>
    <div class="sir-left-side">
        @if (eyebrow) {
            <span class="sir-text-with-intro-eyebrow">{{ eyebrow }}</span>
        }
        <sirius-heading
            [text]="title"
            [textStyleCategory]="titleCategory"
            [textStyleSize]="titleSize"
        ></sirius-heading>
        @if (subTitleHtml) {
            <div class="sir-text">
                <sirius-text-html [html]="subTitleHtml" textStyleSize="l"></sirius-text-html>
            </div>
        }
    </div>
    <div class="sir-right-side">
        <sirius-text-html [html]="textHtml" textStyleSize="m"></sirius-text-html>
    </div>
</sirius-grid>
